export const MENU_ITEMS = [
    {
        id: 'dashboard',
        group: 'DASHBOARD',
        label: 'Dashboard',
        icon: 'home',
        color: '#80deea',
        hasChildMenu: false,
        externalURL: false,
        url: '/home',
    },
    {
        id: 'memberProfile',
        group: 'PROFILE',
        label: 'Member Profile',
        icon: 'account_circle',
        color: '#80deea',
        hasChildMenu: false,
        externalURL: false,
        url: '/profile',
    },
    {
        id: 'myCertWallet',
        group: 'CERTWALLET',
        label: 'Wallet',
        icon: 'task',
        color: '#80deea',
        hasChildMenu: false,
        externalURL: false,
        url: '/my-wallet',
    },
    {
        id: 'ceTrainingPortal',
        group: 'TRAINING_PORTAL',
        label: 'CE Training Portal',
        icon: 'list',
        color: '#80deea',
        hasChildMenu: false,
        externalURL: false,
        url: '/ceu',
    },
    {
        id: 'walletSupport',
        group: 'WALLET_SUPPORT',
        label: 'Support',
        icon: 'email',
        color: '#80deea',
        hasChildMenu: false,
        externalURL: false,
        url: '/wallet-support',
    },
    {
        id: 'upgradePlan',
        group: 'UPGRADE_PLAN',
        label: 'Upgrade Plan',
        icon: 'paid',
        color: '#80deea',
        hasChildMenu: false,
        externalURL: false,
        url: '/upgrade-plan',
    },
    {
        id: 'ambassador',
        group: 'AMBASSADOR',
        label: 'Ambassador',
        isAmbassador: true,
        icon: 'handshake',
        color: '#80deea',
        hasChildMenu: false,
        externalURL: false,
        url: '/brand',
    },

    {
        id: 'administrator',
        group: 'ADMINISTRATOR',
        label: 'Backoffice',
        icon: 'admin_panel_settings',
        color: '#80deea',
        isAdmin: true,
        hasChildMenu: false,
        externalURL: false,
        url: '/office',
    },

];
